import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import MoveCopyToProjectDialog from "../MoveCopyToProject/MoveCopyToProjectDialog.js";

const PrefetchAllProjectsContainer = ({ onMoveCopyToProject, onCancel, projectId, open }) => {
  const { t } = useTranslation();

  return (
    <MoveCopyToProjectDialog
      open={open}
      onSubmit={onMoveCopyToProject}
      onCancel={onCancel}
      excludeIds={[projectId]}
      explainer={t("Moving the task between projects will disconnect it from all of its dependencies.")}
      type="Task List"
    />
  );
};

PrefetchAllProjectsContainer.propTypes = {
  projectId: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onMoveCopyToProject: PropTypes.func,
  onCancel: PropTypes.func,
};

export default PrefetchAllProjectsContainer;
